import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import DrawerV2 from '../Drawer/DrawerV2';

import './FAQSectionV2.css';

export const FAQSectionV2 = ({
  children,
  expandedByDefault,
  title,
  headerElement: HeaderElement = 'h2',
  maxHeight,
  maxExpandedHeight,
  offset,
  className,
  ...props
}) => {
  const classes = cx('faq-section-v2', className);
  return (
    <section className="faq-section-container-v2">
      {title && (
        <HeaderElement className={cx('faq-section-v2__title', `zui__${HeaderElement}`)}>
          {title}
        </HeaderElement>
      )}
      <div className={classes} {...props}>
        <DrawerV2
          maxHeight={maxHeight}
          maxExpandedHeight={maxExpandedHeight}
          offset={offset}
          expandedByDefault={expandedByDefault}
        >
          {children}
        </DrawerV2>
      </div>
    </section>
  );
};

FAQSectionV2.propTypes = {
  className: PropTypes.string,
  expandedByDefault: PropTypes.bool,
  title: PropTypes.string,
  headerElement: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span']),
  maxHeight: PropTypes.string,
  maxExpandedHeight: PropTypes.string,
  offset: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default FAQSectionV2;
